export { Api } from './api/api';
export { User } from './user/user';
export { Tender } from './tender/tender';
export { Master } from './master/master';
export { Schedule } from './schedule/schedule';
export { Task } from './task/task';
export { Notes } from './notes/notes';
export { Dokumen } from './dokumen/dokumen';
export { Subscriber } from './subscriber/subscriber';



// WEBPACK FOOTER //
// ./src/providers/marketing/index.ts